import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { SiteConfigState } from "src/app/models/site.config.models";
import { CallToAction } from "talos-careers-page-library";

@Injectable()
export class CallToActionService {
  constructor(
    private router: Router,
  ) {}

  public tryNavigateToPage(callToAction: CallToAction, siteConfig: SiteConfigState): void {
    const pageNavigation = siteConfig.navigation.siteNavigationItems.find(nav => nav.pageId === callToAction.pageId);

    if (pageNavigation) {
      this.router.navigate([pageNavigation.navigationUrl]);
    } else {
      console.warn(`Unable to navigate to page with the id ${callToAction.pageId}`);
    }
  }
}
